import ContactList from '@/views/contacts/index.vue';
import { Roles } from '@common/app.config';

const authMeta = {
  auth: true,
  authorize: [Roles.superAdmin, Roles.customerService],
};

export default [
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactList,
    meta: authMeta,
  },
];
